<div class="resend-dialog">
  <div class="resend-dialog__header">
    <mat-icon (click)="onCancel()" aria-label="Cerrar diálogo">close</mat-icon>
  </div>
  <div class="resend-dialog__container">
    @if (resendMutation.result$ | async; as result) { @if (result.isPending) {
    <app-horus-loading></app-horus-loading>
    } @else if (result.isSuccess) {
    <app-horus-message-general
      nameIcon="successMessageIcon"
      btnAction="¡LISTO!"
      size="M"
      (action)="action()"
    >
      <p class="title-ok">¡Completado!</p>
      Reenviaste la comunicación de manera correcta.
    </app-horus-message-general>
    } @else if (result.isError) {
      <div class="resend-dialog__message">
        <app-horus-message-general
          nameIcon="errorMessageIcon"
          btnAction="INTENTAR NUEVAMENTE"
          btnCancel="CANCELAR"
          (actionCancel)="onCancel()"
          (action)="onResendMail()">
          <span class="error-title">Lo sentimos</span>
          <span class="error-text">
            Hubo un error al intentar reenviar la comunicación. 
          </span> 
        </app-horus-message-general>
      </div>
    } @else {
    <div class="resend-content justify-center flex flex-col items-center">
      <div>
        <app-send-icon></app-send-icon>
      </div>
      <p class="text-center text-[#505050] text-[18px]">
        Estás a punto de reenviar esta comunicación al destinatario
      </p>
      <div class="resend-dialog__message__tag">
        <app-message-type-label
          [messageType]="data.messageType"
        ></app-message-type-label>
      </div>
      <p class="text-black-70 font-[700] mt-2">
        {{ this.data.to }}
      </p>
      <p class="text-confirm"> ¿Quieres confirmar su <strong class="text-black-70">reenvío</strong>?</p>
      <div class="flex gap-x-2 mt-4">
        <button horusBtn horusBtnVariant="outline-default" horusBtnSize="md" (click)="onCancel()">
          CANCELAR
        </button>
        <button horusBtn horusBtnSize="md" (click)="onResendMail()">CONFIRMAR</button>
      </div>
    </div>
    } }
  </div>
</div>
